import { observer } from 'mobx-react-lite'
import { BookingWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/BookingWidget'
import { KnowledgeBaseWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/KnowledgeBaseSection/KnowledgeBaseWidget'
import { TriggerWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/TriggerSection/TriggerWidget'
import { AutoFollowUpWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/AutoFollowUpSection/AutoFollowUpWidget'
import { InstructionsWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/InstructionsWidget'
import { ActionsWidget } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ActionsWidget'

type IWidgetsProps = {
  widgetId: string
}

export const Widgets = observer(({ widgetId }: IWidgetsProps) => {
  switch (widgetId) {
    case 'booking':
      return <BookingWidget />
    case 'knowledge_base':
      return <KnowledgeBaseWidget />
    case 'trigger_conditions':
      return <TriggerWidget />
    case 'followup':
      return <AutoFollowUpWidget />
    case 'fields_selector':
      return <InstructionsWidget />
    case 'add_actions':
      return <ActionsWidget />
    default:
      return null
  }
})
